import React, { useState, useEffect, useRef } from 'react';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import { toast } from 'react-toastify';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Zoom from '@mui/material/Zoom';
import { httpGet } from '../../HttpRequestHandling/httpRequestHandler';
import EnhancedDataGrid from '../Common/EnhancedDataGrid';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { isNewUi } from '../../redesign/uiMode';
import { LOOKUP_CANCEL, lookupDialogProps } from '../../redesign/shell/lookupCancel';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Zoom in={true} ref={ref} {...props} />;
});

export const ProductLookup = ({ info, onClose }) => {
    const [data, setData] = useState([]);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [inProgress, setInProgress] = useState(false);
    const prevOpenDialog = useRef(false);

    useEffect(() => {
        const openDialog = info?.openDialog;
        if (openDialog && !inProgress && prevOpenDialog.current !== openDialog) {
            setInProgress(true);
            setData([]);
            info.inProgress(true);

            const clientCode = info.invoiceModel.clientCode;
            const selectedProductCode = info.invoiceModel.selectedProductCode;
            const url = `/api/lookup/product/${encodeURIComponent(clientCode)}`;

            httpGet(url)
                .then((response) => {
                    const rows = response.data.map((row, index) => ({ ...row, rowId: index + 1 }));

                    if (selectedProductCode) {
                        const idx = rows.findIndex(r => r.productCode === selectedProductCode);
                        if (idx !== -1) {
                            const [selectedRow] = rows.splice(idx, 1);
                            rows.unshift(selectedRow);
                            rows.forEach((row, i) => { row.rowId = i + 1; });
                        }
                    }

                    const selectedRow = info.shouldSelectProduct
                        ? rows.find(row => row.productCode === selectedProductCode)
                        : null;

                    setData(rows);
                    setSelectedRowId(selectedRow ? selectedRow.rowId : null);
                    setInProgress(false);
                    info.inProgress(false);
                })
                .catch(() => {
                    setInProgress(false);
                    info.inProgress(false);
                    toast.error('An error occurred while fetching the records');
                });
        }
        prevOpenDialog.current = openDialog;
    }, [info?.openDialog]);

    const checkbox_clickHandler = (event) => {
        const rowId = parseInt(event.target.value, 10);
        setSelectedRowId((prev) => (prev === rowId ? null : rowId));
    };

    const close_clickHandler = (event) => {
        const selectedProduct = data.find((row) => row.rowId === selectedRowId);
        if (onClose) {
            onClose(event, selectedProduct || null);
        }
    };

    // New UI: close without applying (Cancel, ✕ and Escape).
    const cancel_clickHandler = (event) => {
        if (onClose) {
            onClose(event, LOOKUP_CANCEL);
        }
    };

    const openDialog = info?.openDialog || false;
    const newUi = isNewUi();

    return (
        <Dialog open={openDialog} TransitionComponent={Transition} fullWidth maxWidth="lg" {...lookupDialogProps(newUi)}>
            <DialogTitle>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>Select Product</span>
                    <IconButton
                        aria-label="close"
                        onClick={newUi ? cancel_clickHandler : close_clickHandler}
                        style={{
                            position: "relative",
                            right: '-1.5%',
                            float: "right",
                            top: '10%',
                            color: (theme) => theme.palette.grey[500]
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </div>
            </DialogTitle>
            <DialogContent>
                <div style={{ display: 'block', overflow: 'auto', width: '100%' }}>
                    <EnhancedDataGrid
                        rows={data}
                        disableColumnMenu
                        pagination
                        pageSize={10}
                        columns={[
                            {
                                headerName: ' ',
                                field: 'chkProduct',
                                width: 40,
                                resizable: false,
                                sortable: false,
                                renderCell: (rowData) => (
                                    <Checkbox
                                        color="default"
                                        name="chk"
                                        checked={selectedRowId === rowData.row.rowId}
                                        value={rowData.row.rowId}
                                        onClick={checkbox_clickHandler}
                                    />
                                ),
                            },
                            {
                                headerName: 'Product Code',
                                field: 'productCode',
                                flex: 0.3,
                            },
                            {
                                headerName: 'Product Name',
                                field: 'productName',
                                flex: 0.4,
                            },
                        ]}
                        getRowId={(row) => row.rowId}
                        disableSelectionOnClick
                    />
                </div>
            </DialogContent>
            <DialogActions>
                {newUi ? <Button onClick={cancel_clickHandler} data-apw2-dismiss="true">Cancel</Button> : null}
                <Button autoFocus onClick={close_clickHandler} color="primary">
                    {newUi && selectedRowId != null ? 'Select' : 'Close'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
